import { CUSTOM_ELEMENTS_SCHEMA, EnvironmentInjector, ErrorHandler, NgModule } from "@angular/core";
import { datadogRum } from "@datadog/browser-rum";

import { config } from "config/environment";
import { ENVS } from "config/envs";
import { MainModule } from "../main/main.module";
import { AppComponent } from "./components";
import { InitResolver } from "../../routing";
import { OnfidoModule } from "../onfido/onfido.module";
import { AuthModule, EnvNameType } from "bp-authorization-lib";
import { ModalModule } from "../app-modal/modal.module";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { BrowserModule } from "@angular/platform-browser";
import { provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import { GraphQLModule } from "../../api/graphql/graphql.module";
import { ChartModule } from "../shared/chart/chart.module";
import { FirebaseModule } from "@core-services/firebase/firebase.module";
import { LoadingService } from "@main-services/loading.service";
import { CookieBannerService } from "@main-services/cookie-banner.service";
import { SiftScienceService } from "@core-services/sift-science.service";
import { CoreModule } from "../core/core.module";
import { RouteReuseStrategy, RouterModule } from "@angular/router";
import { UniversalModalModule } from "@modules/+new/shared/universal-modal/universal-modal.module";
import { UniversalModalService } from "@modules/+new/shared/universal-modal/universal-modal.service";
import { NotificationBellModule } from "@modules/notifications/features/notification-bell/notification-bell.module";
import { ComponentsAngularModule } from "@bitpanda-design-system/angular";
import { CustomRouteReuseStrategy } from "@modules/transaction/custom-route-reuse-strategy";
import { NgOptimizedImage } from "@angular/common";
import { AdvancedTradingModule } from "@modules/advanced-trading/advanced-trading.module";
import { UKFinPromModule } from "@modules/uk-finprom/ukfinprom.module";
import { SecurityAntiPhishingModule } from "@modules/shared/modals/anti-phishing-code-modal/anti-phishing-code.module";
import { StatsigModule } from "@core-services/statsig/statsig.module";
import { ServiceLocator } from "@helpers/service-locator";

class DatadogErrorHandler {
	public handleError(error): void {
		const ddSdkInitialised = !!datadogRum?.getInternalContext();

		if (ddSdkInitialised) {
			datadogRum.addError(error);
		}

		if (config.envName !== ENVS.PROD) {
			console.error(error);
		}
	}
}

@NgModule({
	declarations: [AppComponent],
	bootstrap: [AppComponent],
	schemas: [CUSTOM_ELEMENTS_SCHEMA],
	exports: [RouterModule],
	imports: [
		CoreModule,
		UniversalModalModule,
		ModalModule,
		RouterModule,
		MainModule,
		OnfidoModule,
		BrowserModule,
		BrowserAnimationsModule,
		AuthModule.forRoot({
			envName: config.authEnvName as EnvNameType // Change needed for UK
		}),
		GraphQLModule,
		ChartModule,
		StatsigModule,
		FirebaseModule.forRoot({ apiKey: config.firebaseApiKey }),
		NotificationBellModule,
		ComponentsAngularModule,
		NgOptimizedImage,
		AdvancedTradingModule,
		SecurityAntiPhishingModule,
		UKFinPromModule,
		StatsigModule
	],
	providers: [
		InitResolver,
		{
			provide: ErrorHandler,
			useClass: DatadogErrorHandler
		},
		{
			provide: RouteReuseStrategy,
			useClass: CustomRouteReuseStrategy
		},
		UniversalModalService,
		LoadingService,
		CookieBannerService,
		provideHttpClient(withInterceptorsFromDi())
	]
})
export class AppModule {
	// eslint-disable-next-line
	public constructor(siftScienceService: SiftScienceService, environmentInjector: EnvironmentInjector) {
		ServiceLocator.injector = environmentInjector;
	}
}
